import React, { Component } from 'react';
import ReactDOMServer from 'react-dom/server';
import { Grid, Button, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import Dropdown from 'react-dropdown';
import DetailsModal from './Details/DetailsModal';
import NewPortfolioModal from './NewPortfolio/NewPortfolioModal';
import TickerSearch from './TickerSearch/TickerSearch';
import ClientPrintoutModal from '../ClientPrintout/ClientPrintoutModal';
import ReadonlySummary from '../../containers/Dashboard/TaskBar/ReadonlySummary';
import { formatDateYYYYMMDD } from '../../containers/Dashboard/Helpers';
import {
  changePortfolio,
  createNewPortfolio,
  addUserError,
  generatePrintout
} from '../../actions';
import './SubNav.css';

const printoutDropdown = [
  { label: 'Dashboard Printout', value: 'dashboard' },
  { label: 'Client Printout', value: 'client' }
];

class SubNav extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetailsModal: false,
      showNewPortfolioModal: false,
      showClientPrintoutModal: false
    };
  }

  showModal = (name) => {
    this.props.addUserError(null);
    this.setState({ [name]: true });
  }

  closeModal = (name) => {
    this.setState({ [name]: false });
  }

  onChangePortfolio = (option) => {
    this.props.changePortfolio({
      activePortfolioUserId: this.props.session.activePortfolioUser.id,
      changePortfolioUserId: option.value
    });
  }

  onGeneratePrintout = () => {
    const { quarterInfo } = this.props.user;

    const dashboardBody = document.getElementById('dashboard-table').outerHTML;
    const taskbarBody = document.getElementsByClassName('summary')[0].outerHTML;
    const summaryBody = ReactDOMServer.renderToStaticMarkup(
      <ReadonlySummary
          quarterInfo={quarterInfo} />
    );
    const date = formatDateYYYYMMDD(new Date());

    const htmlBody = `<div class="top-wrapper">
                        <img class="logo" src="https://www.scmportfolio.com/logo.png" alt="Logo" />
                        ${summaryBody}${taskbarBody}
                        <div class="date">
                          ${date}
                        </div>
                      </div>
                      ${dashboardBody}`;

    this.props.generatePrintout({
      htmlBody: htmlBody,
      type: 'dashboard'
    });
  }

  onPrintoutSelect = (e) => {
    switch (e.value) {
      case 'dashboard':
        this.onGeneratePrintout();
        break;
      case 'client':
        this.showModal('showClientPrintoutModal');
        break;
      default: break;
    }
  }

  render() {

    if (!this.props.auth.authenticated) return null;
    if (this.props.session.isAccountEmpty === null) return null;

    const { activePortfolioUser, portfolios } = this.props.session;

    const dropdownOptions = portfolios.map((item) => {
      return {
        label: `${item.name} (${item.privilege})`,
        value: item.id
      }
    });

    return (
      <Grid fluid id="sub-nav">

      <DetailsModal
        showDetailsModal={this.state.showDetailsModal}
        closeModal={this.closeModal} />

      <NewPortfolioModal
        createNewPortfolio={this.props.createNewPortfolio}
        showNewPortfolioModal={this.state.showNewPortfolioModal}
        closeModal={this.closeModal} />

      <ClientPrintoutModal
        showClientPrintoutModal={this.state.showClientPrintoutModal}
        closeModal={this.closeModal} />

        <Row>
          <Col md={7} className="section section-left">

            <Dropdown
              value={activePortfolioUser ? { label: `${activePortfolioUser.name} (${activePortfolioUser.privilege})`,
                value: activePortfolioUser.id } : null}
              options={dropdownOptions}
              className="portfolio-dropdown"
              onChange={this.onChangePortfolio} />

            { !this.props.session.isAccountEmpty && <Button
              onClick={() => this.showModal('showDetailsModal')}>
              Details
            </Button> }

            <Button
              onClick={() => this.showModal('showNewPortfolioModal')}>
              New Portfolio
            </Button>

          </Col>
          <Col md={5} className="section section-right">

            <Dropdown
              value={null}
              options={printoutDropdown}
              className="portfolio-dropdown"
              placeholder="Generate Printout"
              onChange={this.onPrintoutSelect} />

            <TickerSearch />
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps ({ auth, session, user }) {
  return {
    auth,
    session,
    user
  }
}

export default connect(mapStateToProps, {
  changePortfolio,
  createNewPortfolio,
  addUserError,
  generatePrintout
})(SubNav);
